import script from "./GestionPesosView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GestionPesosView.vue?vue&type=script&lang=ts&setup=true"

import "./GestionPesosView.vue?vue&type=style&index=0&id=e6856bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6856bd8"]])

export default __exports__